/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForeignFactories.vue?vue&type=template&id=55ff100b&scoped=true&"
import script from "./ForeignFactories.vue?vue&type=script&lang=js&"
export * from "./ForeignFactories.vue?vue&type=script&lang=js&"
import style0 from "./ForeignFactories.vue?vue&type=style&index=0&id=55ff100b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff100b",
  null
  
)

export default component.exports